"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var sha3_1 = require("sha3"),
    version_1 = require("../version"),
    DeviceUtils_1 = require("./DeviceUtils"),
    DataBuilder = function () {
  function e(e) {
    this.sdk = e, this.window = void 0, this.customPayload = null, this.touchData = [], this.isCheckSumAndSignatureEnabled = !1, this.window = window;
  }

  return e.prototype.setWindow = function (e) {
    return this.window = e, this;
  }, e.prototype.setTouchData = function (e) {
    var t = DeviceUtils_1.default.pageZoomFactor();
    return 1 !== t && e.forEach(function (e) {
      e.x = e.x * t, e.y = e.y * t;
    }), this.touchData = e, this;
  }, e.prototype.setCustomPayload = function (e) {
    return this.customPayload = e, this;
  }, e.prototype.enableCheckSumAndSignature = function () {
    return this.isCheckSumAndSignatureEnabled = !0, this;
  }, e.prototype.buildJSON = function () {
    var e = "",
        t = "";
    this.isCheckSumAndSignatureEnabled && (e = this.sdk.getSessionToken(), t = new sha3_1.SHA3(512).update(JSON.stringify(this.touchData) + e).digest("hex"));
    var i = navigator.userAgent;
    return {
      checksum: t,
      customData: this.customPayload,
      deviceInfo: {
        appType: this.sdk.getAppType(),
        gpuRenderer: DeviceUtils_1.default.gpuRenderer(),
        manufacturer: DeviceUtils_1.default.manufacturer(),
        model: DeviceUtils_1.default.iOSModel(),
        userAgent: i,
        webglfp: DeviceUtils_1.default.webglFingerprint()
      },
      deviceOS: {
        osname: DeviceUtils_1.default.oSName(),
        version: DeviceUtils_1.default.oSVersion()
      },
      deviceScreen: {
        coordinatesUnit: this.sdk.getCoordinatesUnit(),
        devicePixelRatio: this.window.devicePixelRatio,
        height: this.window.screen.height,
        width: this.window.screen.width
      },
      installationID: this.sdk.getUUID(),
      sdkVersion: version_1.version,
      signature: e,
      touchData: this.touchData
    };
  }, e.prototype.buildJSONStringify = function () {
    return JSON.stringify(this.buildJSON());
  }, e;
}();

exports.DataBuilder = DataBuilder;